import { jsx as e } from "react/jsx-runtime";
import '../../assets/container.css';/* empty css                       */
const a = ({
  children: r,
  className: o = "",
  style: t
}) => /* @__PURE__ */ e(
  "div",
  {
    style: t,
    className: `raise-container ${o}`,
    children: r
  }
);
export {
  a as Container
};
